import React, {useEffect, useState} from 'react';
import {useCurrentCompanyQuery, useListCompaniesQuery} from "apis/companiesApi";
import {AutoComplete} from "primereact/autocomplete";
import {useCompany} from "../../hooks/companyHooks";
import {useDispatch} from "react-redux";
import {changeStatus} from "../../redux/slices/statusSlice";

const CompanySelector = () => {
    const dispatch = useDispatch();
    const selectCompany = useCompany();
    const {data: companies} = useListCompaniesQuery();
    const {data: currentCompany, isFetching} = useCurrentCompanyQuery();
    const [filteredCompanies, setFilteredCompanies] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(currentCompany);
    const searchCompany = (event) => {
        setTimeout(() => {
            let _filteredCompanies;
            if (!event.query.trim().length) {
                _filteredCompanies = [...companies];
            }
            else {
                _filteredCompanies = companies.filter((company) =>
                    company.name.toLowerCase().startsWith(event.query.toLowerCase())
                );
            }

            setFilteredCompanies(_filteredCompanies);
        }, 250);
    }

    const handleChange = async e => {
        setSelectedCompany(e.value);

        if(e.originalEvent.type === 'click') {
            await selectCompany(e.value);
        }
    }

    useEffect(() => {
        setSelectedCompany(currentCompany);
    }, [currentCompany]);

    useEffect(() => {
        if(companies?.length > 0 && !isFetching && !currentCompany?.id) {
           selectCompany(companies[0])
               .then(() => {
                   dispatch(changeStatus("ok"));});
        }
        else if(!isFetching && companies?.length === 0)
            dispatch(changeStatus("ok"));    
        else if(!isFetching && currentCompany?.id)
            dispatch(changeStatus("ok"));    
    }, [companies, currentCompany, selectCompany, isFetching, dispatch]);

    if(companies?.length === 1) {
        return (<div className="current-company-name">{currentCompany?.name}</div>);
    }
    else if(companies?.length) {
        return (<AutoComplete
            value={selectedCompany}
            suggestions={filteredCompanies}
            completeMethod={searchCompany}
            field="name"
            dropdown
            forceSelection
            onChange={handleChange} />)
    }
    else {
        return (<></>);
    }
}

export default CompanySelector;
